import { accountStore } from '@/services/auth/store';
import { getRouteOwner } from '@/services/router/route-ownership';
import { useLocation } from '@/services/router/compat';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';

/**
 * Marks `document.body` with the framework serving the current route
 * (`data-route-owner="hydra"` for native React routes, `"embedded"` for
 * Journeys/Ember or Design Studio), so the Ember→React migration state is
 * observable in production (where dev tools are unavailable) even while
 * feature flags flip ownership per account.
 */
export function useRouteOwnerBodyAttribute() {
  const { pathname } = useLocation();

  // getRouteOwner reads the account's feature flags, and flag-gated entries
  // fall back to `embedded` until the account has loaded. Subscribing to the
  // account re-renders this hook when the flags arrive after first render,
  // so the owner below is recomputed without a navigation.
  useStore(accountStore);
  const routeOwner = getRouteOwner(pathname);

  useEffect(() => {
    document.body.dataset.routeOwner = routeOwner;
  }, [routeOwner]);
}
